module.exports = __webpack_public_path__ + "static/media/investment-fund.c65298d4.svg";